export default __webpack_public_path__ + "static/media/stephanie.c0b3c1bd.png";